import { render } from "./EditValueRestrictionComponent.vue?vue&type=template&id=4009f4b6&scoped=true"
import script from "./EditValueRestrictionComponent.vue?vue&type=script&lang=js"
export * from "./EditValueRestrictionComponent.vue?vue&type=script&lang=js"

import "./EditValueRestrictionComponent.vue?vue&type=style&index=0&id=4009f4b6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4009f4b6"]])

export default __exports__